/**
 * Non-dismissable centered card shown for ~1.5s before redirecting to /report.
 */
export function TimeUpOverlay() {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-[var(--bg)]/80 backdrop-blur-sm"
      role="alert"
      aria-live="assertive"
    >
      <div className="rounded-[var(--radius-lg)] border border-[var(--border)] bg-[var(--panel)] px-6 py-5 shadow-[var(--shadow)]">
        <p className="font-serif-italic text-xl text-[var(--ink)]">
          Tijd is om.
        </p>
        <p className="mt-2 text-sm text-[var(--ink-muted)]">
          Uw rapport wordt geopend…
        </p>
      </div>
    </div>
  );
}
